// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Yt1Ei{list-style:none;margin:0;margin:15px 0 0;padding:0}.cSrF1{display:-webkit-box;display:flex;margin-top:-34px}.lXPwC{display:-webkit-box;display:flex;flex-wrap:wrap;margin-top:0;padding:0 22px 8px}@media screen and (min-width:768px){.lXPwC{flex-wrap:nowrap;margin-top:-15px}}.MuQ_r{margin:0 20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Yt1Ei`,
	"root_minimal": `cSrF1`,
	"root_withinDatePicker": `lXPwC`,
	"root_instabook": `MuQ_r`
};
module.exports = ___CSS_LOADER_EXPORT___;
